<script lang="ts">
import { push } from "svelte-spa-router";
import PageTitle from "../molecules/PageTitle.svelte";

</script>

<PageTitle>
	<h1 slot="title">
		お問い合わせ
	</h1>

	<div slot="subtitle">
		お問い合わせ一覧を表示します。
	</div>
</PageTitle>